var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "track",
    class: {
      expanded: _vm.track.expanded
    },
    attrs: {
      "id": 'track' + _vm.track.tour_index
    }
  }, [_c('div', {
    staticClass: "track-heading"
  }, [_c('h2', {
    staticClass: "artist",
    on: {
      "click": _vm.toggle
    }
  }, [_c('span', {
    staticClass: "track-number"
  }, [_vm._v(_vm._s(_vm.track.tour_index))]), _vm._v(" "), _c('span', {
    staticClass: "track-name"
  }, [_vm._v(_vm._s(_vm.track.artist))])]), _vm._v(" "), _c('h3', {
    staticClass: "art"
  }, [_vm._v(_vm._s(_vm.track.title))]), _vm._v(" "), _c('h3', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "track-length"
  }, [_vm._v(_vm._s(_vm.track.length))]), _vm._v(" "), _c('span', {
    staticClass: "track-location"
  }, [_vm._v(_vm._s(_vm.track.location))])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('track-list-detail', {
    attrs: {
      "track": _vm.track
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a9ec604","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListenPage/TrackListItem.vue
// module id = v2FW
// module chunks = 1